import { render, staticRenderFns } from "./MainProduct.vue?vue&type=template&id=1b47e7dd&scoped=true&"
import script from "./MainProduct.vue?vue&type=script&lang=js&"
export * from "./MainProduct.vue?vue&type=script&lang=js&"
import style0 from "./MainProduct.vue?vue&type=style&index=0&id=1b47e7dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47e7dd",
  null
  
)

export default component.exports